import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { NotificationSection } from 'components/settings';
import './Notifications.css';

export const Notifications: React.FC = () => {
    const navigate = useNavigate();
    const [pushEnabled, setPushEnabled] = useState(true);
    const [meetingReminder, setMeetingReminder] = useState(true);
    const [chatNotification, setChatNotification] = useState(true);
    const [scheduleNotification, setScheduleNotification] = useState(true);
    const [costNotification, setCostNotification] = useState(false);

    return (
        <div className="notifications-wrapper">
            <div className="notifications-header">
                <button className="back-button" onClick={() => navigate('/settings')}>
                    ←
                </button>
                <h1 className="notifications-title">알림 설정</h1>
            </div>

            <div className="notifications-content">
                <div className="notifications-description">
                    <h2 className="description-title">알림 관리</h2>
                    <p className="description-text">
                        받고 싶은 알림을 선택하세요.
                    </p>
                </div>

                <NotificationSection
                    items={[{
                        label: '전체 푸시 알림',
                        description: '모든 알림을 받습니다',
                        checked: pushEnabled,
                        onChange: setPushEnabled
                    }]}
                />

                <NotificationSection
                    title="모임 알림"
                    items={[{
                        label: '모임 시작 알림',
                        description: '모임 30분 전 알림을 받습니다',
                        checked: meetingReminder,
                        disabled: !pushEnabled,
                        onChange: setMeetingReminder
                    }]}
                />

                <NotificationSection
                    title="채팅 알림"
                    items={[{
                        label: '새 메시지 알림',
                        description: '새로운 채팅 메시지를 받았을 때 알림',
                        checked: chatNotification,
                        disabled: !pushEnabled,
                        onChange: setChatNotification
                    }]}
                />

                <NotificationSection
                    title="일정 알림"
                    items={[{
                        label: '일정 조율 완료',
                        description: '일정 조율이 완료되면 알림',
                        checked: scheduleNotification,
                        disabled: !pushEnabled,
                        onChange: setScheduleNotification
                    }]}
                />

                <NotificationSection
                    title="정산 알림"
                    items={[{
                        label: '정산 요청',
                        description: '정산 요청이 있을 때 알림',
                        checked: costNotification,
                        disabled: !pushEnabled,
                        onChange: setCostNotification
                    }]}
                />
            </div>
        </div>
    );
};
